import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { LOAD_MYCHART_TERMS_DATA_START } from "../../constants/actionTypes";

class Terms extends React.Component {
    constructor(props) {
        super(props);
        this.toggleTabs = this.toggleTabs.bind(this);
        this.state = { activeTab: '1' };
    }

    //componentWillMount() {
    //this.props.getMyChartTerms(); 
    //}

    toggleTabs(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    render() {
        const { myChartTerms, isLoggedIn, bswhealthUrl } = this.props;
        
        //const obj = myChartTerms && myChartTerms.length>0 ? JSON.parse(myChartTerms):null;
        const termsObject = myChartTerms;// && myChartTerms.length>0 ? JSON.parse(myChartTerms):null;
        var aboutUrl = `${bswhealthUrl}about/pages/default.aspx`;

        return (
            <div className={"container-fluid body-content terms-container" + (isLoggedIn ? " logged-in-container" : " logged-out-container")}>
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-heading">Terms and Conditions</div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                {termsObject &&
                                    <div className="terms-text">
                                        <div dangerouslySetInnerHTML={{ __html: termsObject }} />

                                    </div>
                                }
                                {/*
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink className={this.state.activeTab === '1' ? 'active' : ''} onClick={() => this.toggleTabs('1')}>
                                            MYBSWHEALTH
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink className={this.state.activeTab === '2' ? 'active' : ''} onClick={() => this.toggleTabs('2')}>
                                            MYCHART
                                         </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={this.state.activeTab}>
                                    <TabPane tabId="1">
                                        {this.props.myChartTermsInProcess 
                                            ? <div className="spinner">
                                                <div className="bounce1" />
                                                <div className="bounce2" />
                                                <div className="bounce3" />
                                            </div>
                                            : obj && obj.MyBSWHealth ? <div dangerouslySetInnerHTML={{ __html: obj.MyBSWHealth }} />:''
                                        }
                                    </TabPane>
                                    <TabPane tabId="2">
                                        {this.props.myChartTermsInProcess 
                                            ? <div className="spinner">
                                                <div className="bounce1" />
                                                <div className="bounce2" />
                                                <div className="bounce3" />
                                            </div>
                                            : obj && obj.MyChart ? <div dangerouslySetInnerHTML={{ __html: obj.MyChart }} /> : ''
                                        }
                                    </TabPane>
                                </TabContent>
                                */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        myChartTerms: state.session.terms,
        isLoggedIn: state.domain.li,
        bswhealthUrl: state.session.serverData ? state.session.serverData.bswHealthUrl : ""
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Terms);